import {useEffect} from 'react';

function useBrowserTitle(title) {
    useEffect(() => {
        if (title) {
            document.title = `MM-SEAS ${title}`;
        }
        return () => (document.title = `MM-SEAS`);
    }, [title]);
}

export default useBrowserTitle;
